import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const NewsSkeletonLoading: React.FunctionComponent = () => {
  return (
    <div className="mb-8 h-screen px-4">
      <div className="flex space-x-2">
        <Skeleton width={40} />
        <Skeleton width={40} />
      </div>
      <div className="mb-2 w-[300px]">
        <Skeleton />
      </div>
      <div className="mb-2">
        <Skeleton />
      </div>
      <p className="w-[150px]">
        <Skeleton />
      </p>
    </div>
  );
};

export default NewsSkeletonLoading;
